import { Box } from '@mui/material';
import { clsx } from 'clsx';

import styles from './InfoCardTemplate.module.scss';

interface IInfoCardTemplateProps {
  label: string;
  value: string;
  containerStyles?: string;
  labelStyles?: string;
  valueStyles?: string;
  onClick?: () => void;
}

export const InfoCardTemplate: React.FC<IInfoCardTemplateProps> = ({
  label,
  value,
  containerStyles,
  labelStyles,
  valueStyles,
  onClick,
}) => (
  <Box className={clsx(styles.container, containerStyles)} onClick={onClick}>
    <Box className={clsx(styles.label, labelStyles)}>{label}</Box>
    <Box className={clsx(styles.value, valueStyles)}>{value}</Box>
  </Box>
);
